import fetch from 'isomorphic-fetch';
import { sessionService } from 'redux-react-session';
import { browserHistory } from 'react-router';

import makeActionCreator from '../../utils/makeActionCreator';
import * as API from '../../utils/config-api';
import * as endpoints from './endpoints';
import { logout } from '../../auth/list';

export const SETTINGS_RESOURCES_INSIGHT_PENDING = 'SETTINGS_RESOURCES_INSIGHT_PENDING';
export const settingsInsightsResourcesPending = makeActionCreator(
  SETTINGS_RESOURCES_INSIGHT_PENDING,
);

export const SETTINGS_RESOURCES_INSIGHT_REJECTED = 'SETTINGS_RESOURCES_INSIGHT_REJECTED';
export const settingsInsightsResourcesRejected = makeActionCreator(
  SETTINGS_RESOURCES_INSIGHT_REJECTED,
);


export const SETTINGS_RESOURCES_INSIGHT_SHOW_ITEM = 'SETTINGS_RESOURCES_INSIGHT_SHOW_ITEM';
export const settingsInsightsResourcesShowItem = makeActionCreator(
  SETTINGS_RESOURCES_INSIGHT_SHOW_ITEM,
  'itemId',
);

// Show Index

export const SETTINGS_RESOURCES_INSIGHT_LIST_FULFILLED = 'SETTINGS_RESOURCES_INSIGHT_LIST_FULFILLED';
export const settingsInsightsResourcesListFulfilled = makeActionCreator(SETTINGS_RESOURCES_INSIGHT_LIST_FULFILLED, 'data', 'pagination', 'currentPage');

export const SETTINGS_RESOURCES_INSIGHT_LIST_ERROR = 'SETTINGS_RESOURCES_INSIGHT_LIST_ERROR';
export const settingsInsightsResourcesListError = makeActionCreator(SETTINGS_RESOURCES_INSIGHT_LIST_ERROR, 'message');

export function resourcesInsightsList(page = 1) {
  return (dispatch) => {
    sessionService.loadSession().then((currentSession) => {
      dispatch(settingsInsightsResourcesPending());
      return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.InsightsResourcesList.version}${endpoints.InsightsResourcesList.path}?page=${page}`, {
        method: endpoints.InsightsResourcesList.method,
        headers: {
          Authorization: `Bearer ${currentSession.token}`,
          Accept: 'application/json',
        },
      })
        .then(API.checkStatus)
        .then(API.parseJSON)
        .then((json) => {
          const paginationData = {
            first_page_url: json.first_page_url,
            from: json.from,
            last_page: json.last_page,
            last_page_url: json.last_page_url,
            next_page_url: json.next_page_url,
            per_page: json.per_page,
            prev_page_url: json.prev_page_url,
            to: json.to,
            total: json.total,
          };
          dispatch(settingsInsightsResourcesListFulfilled(json.data, paginationData, page));
        })
        .catch((err) => {
          // Dispatch the error action with error information
          dispatch(settingsInsightsResourcesRejected(err));
        });
    })
      .catch(() => {
        dispatch(logout(() => browserHistory.push('/login')));
      });
  };
}

// Add new

export const SETTINGS_RESOURCES_INSIGHT_ITEM_ADD_FULFILLED = 'SETTINGS_RESOURCES_INSIGHT_ITEM_ADD_FULFILLED';
export const settingsInsightsResourcesAddFulfilled = makeActionCreator(SETTINGS_RESOURCES_INSIGHT_ITEM_ADD_FULFILLED, 'data');

export const SETTINGS_RESOURCES_INSIGHT_ITEM_ADD_ERROR = 'SETTINGS_RESOURCES_INSIGHT_ITEM_ADD_ERROR';
export const settingsInsightsResourcesAddError = makeActionCreator(SETTINGS_RESOURCES_INSIGHT_ITEM_ADD_ERROR, 'message');

export function settingsInsightsResourcesAddItem(data) {
  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('version', data.version);

  if (data.resource_1 || data.resource_1 === null) {
    formData.append('resource_1', data.resource_1 || '');
  }

  if (data.resource_2 || data.resource_2 === null) {
    formData.append('resource_2', data.resource_2 || '');
  }

  if (data.resource_3 || data.resource_3 === null) {
    formData.append('resource_3', data.resource_3 || '');
  }

  return (dispatch) => {
    sessionService.loadSession().then((currentSession) => {
      dispatch(settingsInsightsResourcesPending());
      return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.InsightsResourcesSave.version}${endpoints.InsightsResourcesSave.path}`, {
        method: endpoints.InsightsResourcesSave.method,
        headers: {
          Authorization: `Bearer ${currentSession.token}`,
          Accept: 'application/json',
          // 'Content-Type': 'multipart/form-data',
        },
        body: formData,
      })
        .then(API.checkStatus)
        .then(API.parseJSON)
        .then((json) => {
          if (json.status === 'ok') {
            dispatch(settingsInsightsResourcesAddFulfilled(json.data));
          } else {
            dispatch(settingsInsightsResourcesAddError(json.message));
          }
        })
        .catch((err) => {
          // Dispatch the error action with error information
          dispatch(settingsInsightsResourcesRejected(err));
        });
    })
      .catch(() => {
        dispatch(logout(() => browserHistory.push('/login')));
      });
  };
}

// Edit Item

export const SETTINGS_RESOURCES_INSIGHT_ITEM_UPDATE_FULFILLED = 'SETTINGS_RESOURCES_INSIGHT_ITEM_UPDATE_FULFILLED';
export const settingsInsightsResourcesEditFulfilled = makeActionCreator(SETTINGS_RESOURCES_INSIGHT_ITEM_UPDATE_FULFILLED, 'data');

export const SETTINGS_RESOURCES_INSIGHT_ITEM_UPDATE_ERROR = 'SETTINGS_RESOURCES_INSIGHT_ITEM_UPDATE_ERROR';
export const settingsInsightsResourcesEditError = makeActionCreator(SETTINGS_RESOURCES_INSIGHT_ITEM_UPDATE_ERROR, 'message');

export function settingsInsightsResourcesUpdateItem(itemId, data) {
  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('version', data.version);

  if (data.resource_1 || data.resource_1 === null) {
    formData.append('resource_1', data.resource_1 || '');
  }

  if (data.resource_2 || data.resource_2 === null) {
    formData.append('resource_2', data.resource_2 || '');
  }

  if (data.resource_3 || data.resource_3 === null) {
    formData.append('resource_3', data.resource_3 || '');
  }

  formData.append('_method', 'PUT');

  return (dispatch) => {
    sessionService.loadSession().then((currentSession) => {
      dispatch(settingsInsightsResourcesPending());
      return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.InsightsResourcesEdit.version}${endpoints.InsightsResourcesEdit.path.replace(':insight_resource_id', itemId)}`, {
        method: endpoints.InsightsResourcesEdit.method,
        headers: {
          Authorization: `Bearer ${currentSession.token}`,
          Accept: 'application/json',
          // 'Content-Type': 'multipart/form-data',
        },
        body: formData,
      })
        .then(API.checkStatus)
        .then(API.parseJSON)
        .then((json) => {
          if (json.status === 'ok') {
            dispatch(settingsInsightsResourcesEditFulfilled(json.data));
          } else {
            dispatch(settingsInsightsResourcesEditError(json.message));
          }
        })
        .catch((err) => {
          // Dispatch the error action with error information
          dispatch(settingsInsightsResourcesRejected(err));
        });
    })
      .catch(() => {
        dispatch(logout(() => browserHistory.push('/login')));
      });
  };
}

// Delete Item

export const SETTINGS_RESOURCES_INSIGHT_DELETE_FULFILLED = 'SETTINGS_RESOURCES_INSIGHT_DELETE_FULFILLED';
export const settingsInsightsResourcesDeleteFulfilled = makeActionCreator(SETTINGS_RESOURCES_INSIGHT_DELETE_FULFILLED, 'data');

export const SETTINGS_RESOURCES_INSIGHT_DELETE_ERROR = 'SETTINGS_RESOURCES_INSIGHT_DELETE_ERROR';
export const settingsInsightsResourcesDeleteError = makeActionCreator(SETTINGS_RESOURCES_INSIGHT_DELETE_ERROR, 'message');

export function settingsInsightsResourcesRemoveItem(itemId) {
  return (dispatch) => {
    sessionService.loadSession().then((currentSession) => {
      dispatch(settingsInsightsResourcesPending());
      return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.InsightsResourcesDelete.version}${endpoints.InsightsResourcesDelete.path.replace(':insight_resource_id', itemId)}`, {
        method: endpoints.InsightsResourcesDelete.method,
        headers: {
          Authorization: `Bearer ${currentSession.token}`,
          Accept: 'application/json',
        },
      })
        .then(API.checkStatus)
        .then(API.parseJSON)
        .then((json) => {
          dispatch(settingsInsightsResourcesDeleteFulfilled(json.data));
          dispatch(dispatch(resourcesInsightsList()));
        })
        .catch((err) => {
          // Dispatch the error action with error information
          dispatch(settingsInsightsResourcesRejected(err));
        });
    })
      .catch(() => {
        dispatch(logout(() => browserHistory.push('/login')));
      });
  };
}
